module.exports = __webpack_public_path__ + "img/20201102-2.a7b27dfb.jpg";